module.exports = [{"id":"0","lang":"未设置战区"},{"id":"1","lang":"官方战区"},{"id":"2","lang":"渠道战区"},{"id":"3","lang":"海外互通战区"},{"id":"cjhwy2","lang":"内部战区"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/config/server_pattern.json
// module id = NCoe
// module chunks = 1